(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mount(canvas, sizeEl) {
    if (!canvas || canvas.dataset.odysseeSkyReady === 'true') return;
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    canvas.dataset.odysseeSkyReady = 'true';

    const host = sizeEl || canvas.parentElement || document.body;
    const stars = [];
    const shooting = [];
    let width = 0;
    let height = 0;
    let dpr = 1;
    let lastSpawn = 0;
    let nextSpawn = 380;
    let lastTs = 0;
    let raf = 0;
    let active = true;

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = host.clientWidth || window.innerWidth;
      height = host.clientHeight || window.innerHeight;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function seedStars() {
      stars.length = 0;
      const count = Math.round(Math.min(260, Math.max(130, (width * height) / 8000)));
      for (let i = 0; i < count; i += 1) {
        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: Math.random() * 1.15 + 0.25,
          base: Math.random() * 0.45 + 0.25,
          amp: Math.random() * 0.55 + 0.2,
          speed: Math.random() * 1.6 + 0.6,
          phase: Math.random() * Math.PI * 2,
          gold: Math.random() > 0.35,
        });
      }
    }

    function spawnShooting(now) {
      const fromRight = Math.random() > 0.35;
      shooting.push({
        x: fromRight ? width * (0.2 + Math.random() * 0.75) : width * Math.random() * 0.4,
        y: height * Math.random() * 0.45,
        vx: fromRight ? -(380 + Math.random() * 220) : 360 + Math.random() * 200,
        vy: 160 + Math.random() * 140,
        life: 0,
        max: 0.55 + Math.random() * 0.35,
        len: 70 + Math.random() * 90,
      });
      lastSpawn = now;
      nextSpawn = 900 + Math.random() * 1100;
    }

    function drawStars(now) {
      const t = now / 1000;
      for (let i = 0; i < stars.length; i += 1) {
        const star = stars[i];
        const twinkle = reduceMotion ? star.base : star.base + Math.sin(t * star.speed + star.phase) * star.amp;
        const alpha = Math.max(0.08, Math.min(1, twinkle));
        ctx.beginPath();
        ctx.fillStyle = star.gold
          ? `rgba(248, 208, 64, ${alpha})`
          : `rgba(255, 246, 220, ${alpha})`;
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function drawShooting(dt, now) {
      if (!reduceMotion && now - lastSpawn > nextSpawn) {
        spawnShooting(now);
      }

      for (let i = shooting.length - 1; i >= 0; i -= 1) {
        const s = shooting[i];
        s.life += dt;
        s.x += s.vx * dt;
        s.y += s.vy * dt;

        const fade = 1 - s.life / s.max;
        if (fade <= 0) {
          shooting.splice(i, 1);
          continue;
        }

        const angle = Math.atan2(s.vy, s.vx);
        const tailX = s.x - Math.cos(angle) * s.len;
        const tailY = s.y - Math.sin(angle) * s.len;
        const grad = ctx.createLinearGradient(tailX, tailY, s.x, s.y);
        grad.addColorStop(0, 'rgba(255, 236, 159, 0)');
        grad.addColorStop(0.55, `rgba(255, 226, 140, ${0.25 * fade})`);
        grad.addColorStop(1, `rgba(255, 246, 210, ${0.95 * fade})`);

        ctx.strokeStyle = grad;
        ctx.lineWidth = 1.4;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(tailX, tailY);
        ctx.lineTo(s.x, s.y);
        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = `rgba(255, 248, 220, ${0.9 * fade})`;
        ctx.arc(s.x, s.y, 1.35, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function tick(ts) {
      if (!active) return;
      if (!lastTs) lastTs = ts;
      const dt = Math.min(0.032, (ts - lastTs) / 1000);
      lastTs = ts;

      ctx.clearRect(0, 0, width, height);
      drawStars(ts);
      drawShooting(dt, ts);
      raf = requestAnimationFrame(tick);
    }

    function onResize() {
      if (!active) return;
      resize();
      seedStars();
    }

    resize();
    seedStars();
    lastSpawn = 0;
    nextSpawn = 320;
    window.addEventListener('resize', onResize);
    raf = requestAnimationFrame(tick);

    return function stop() {
      active = false;
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', onResize);
    };
  }

  window.OdysseeSky = { mount };

  document.querySelectorAll('canvas[data-odyssee-sky]').forEach((canvas) => {
    const root = canvas.closest('[data-odyssee-sky-root]') || canvas.parentElement;
    mount(canvas, root);
  });
})();
